export const BASEURL = 'https://v2-uat-api.happay.in/';
